module.exports = __webpack_public_path__ + "static/media/Teppanyaki.96d9be4c.jpg";